import { combine, createEffect, createEvent, createStore } from 'effector';
import IPost from '@interfaces/IPost';
import request from '@helpers/request';
import api from '@constants/endpoints';
import createPreloadersStore from '@stores/preloaders';
import { get } from 'lodash';

export const reset = createEvent('Post selector store reset');

export const getPostById = createEffect({
  name: 'getPostById',
  async handler(postId: IPost['id']) {
    return await request(api.posts.getItem, {
      urlParams: { postId },
    });
  },
});

const preloader = createPreloadersStore([getPostById]);

const post = createStore<{ data: IPost | null; isValid: boolean }>({ data: null, isValid: true })
  .on(getPostById.done, (state, { result }) => {
    return { data: get(result, ['data'], null), isValid: true };
  })
  .on(getPostById.fail, (state, result) => {
    return { data: null, isValid: false };
  })
  .reset(reset);

const postSelector = combine({
  preloader,
  post,
});

export default postSelector;
